(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-christmas-edit"] && !Shopify.designMode) return;
  try {
    
(function(){
  function tick(){
    var now=new Date(),today=new Date(now.getFullYear(),now.getMonth(),now.getDate());
    var x=new Date(now.getFullYear(),11,25),s=Math.round((x-today)/864e5);
    if(s<0){s=Math.round((new Date(now.getFullYear()+1,11,25)-today)/864e5)}
    document.querySelectorAll('[data-bb-count]').forEach(function(el){
      var n=el.querySelector('[data-s]'),l=el.querySelector('[data-sl]'),label=el.getAttribute('data-label')||'';
      if(s===0){el.style.display='none';return}
      if(n)n.textContent=s;
      if(l)l.textContent=s===1?label.replace('sleeps','sleep').replace('Sleeps','Sleep'):label;
    });
  }
  function tabs(root){
    (root||document).querySelectorAll('[data-bb-tabs]').forEach(function(list){
      if(list.dataset.bbReady)return;list.dataset.bbReady='1';
      var btns=[].slice.call(list.querySelectorAll('[role="tab"]'));
      function select(b,focus){
        btns.forEach(function(x){
          var on=x===b,panel=document.getElementById(x.getAttribute('aria-controls'));
          x.setAttribute('aria-selected',on);x.tabIndex=on?0:-1;
          if(panel){panel.hidden=!on;if(on){var t=panel.querySelector('.bb-scroller__track');if(t){t.scrollLeft=0;}}}
        });
        if(focus)b.focus();
        window.dispatchEvent(new Event('resize'));
      }
      btns.forEach(function(b,i){
        b.addEventListener('click',function(){select(b)});
        b.addEventListener('keydown',function(e){
          if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();var n=btns[(i+(e.key==='ArrowRight'?1:btns.length-1))%btns.length];select(n,true);}
        });
      });
    });
  }
  tabs();
  document.addEventListener('shopify:section:load',function(e){tabs(e.target)});
  tick();setInterval(tick,60000);
  document.addEventListener('shopify:section:load',tick);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-editorial-intro"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__bbReveal) return; window.__bbReveal = true;
  function init(){
    var els = document.querySelectorAll('.bb-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); io.unobserve(en.target);} }); }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-storybook"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = window.matchMedia('(min-width: 990px)');
  function init(root){
    if (root.dataset.bbReady) return; root.dataset.bbReady = '1';
    var stories = Array.prototype.slice.call(root.querySelectorAll('[data-story]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var leaf = root.querySelector('[data-leaf]');
    var spread = root.querySelector('[data-bb-spread]');
    var n = stories.length, i = 0, busy = false;
    if (n < 2) return;
    function show(k){
      stories.forEach(function(s, j){
        var on = j === k; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a,button').forEach(function(el){ el.setAttribute('tabindex', on ? '0' : '-1'); });
      });
      tabs.forEach(function(t, j){ t.classList.toggle('is-active', j === k); t.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
      root.style.setProperty('--c', stories[k].getAttribute('data-color'));
      i = k;
    }
    function go(k, dir){
      k = ((k % n) + n) % n; if (k === i || busy) return;
      if (!leaf || reduce || !desk.matches) { show(k); return; }
      busy = true; dir = dir || (k > i ? 1 : -1);
      leaf.className = 'bb-book__leaf ' + (dir > 0 ? 'is-next' : 'is-prev');
      setTimeout(function(){ show(k); }, 380);
      var done = function(){ leaf.className = 'bb-book__leaf'; busy = false; leaf.removeEventListener('animationend', done); };
      leaf.addEventListener('animationend', done);
      setTimeout(function(){ if (busy) done(); }, 1200);
    }
    tabs.forEach(function(t){ t.addEventListener('click', function(){ go(parseInt(t.getAttribute('data-tab'), 10)); }); });
    root.querySelectorAll('[data-turn]').forEach(function(b){ b.addEventListener('click', function(){ go(i + 1, 1); }); });
    root.addEventListener('keydown', function(e){ if (e.target.closest('input,textarea')) return; if (e.key === 'ArrowRight') { go(i + 1, 1); } else if (e.key === 'ArrowLeft') { go(i - 1, -1); } });
    var sx = 0, sy = 0, tracking = false;
    spread.addEventListener('touchstart', function(e){ var t = e.touches[0]; sx = t.clientX; sy = t.clientY; tracking = true; }, { passive: true });
    spread.addEventListener('touchend', function(e){ if (!tracking) return; tracking = false; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) { go(dx < 0 ? i + 1 : i - 1, dx < 0 ? 1 : -1); } }, { passive: true });
    show(0);
  }
  function boot(){ document.querySelectorAll('[data-bb-book]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function(e){ var t = e.target.closest && e.target.closest('[data-tab]'); if (t) t.click(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-type-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function init(root){
    if (root.dataset.bbReady) return; root.dataset.bbReady = '1';
    var stage = root.querySelector('[data-bb-stage]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bb-slide]'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-bb-go]'));
    var counter = root.querySelector('[data-bb-counter]');
    var n = slides.length, i = 0, timer = null, auto = parseFloat(root.getAttribute('data-auto')) || 0;
    if (!n) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function layout(){
      var w = slides[0].offsetWidth, m = mq.matches;
      var c = m ? { x1: .76, x2: 1.36, y1: 16, y2: 32, z1: -90, z2: -180, s1: .86, s2: .72, r1: 20, r2: 28, o2: 0 } : { x1: .84, x2: 1.52, y1: 24, y2: 46, z1: -120, z2: -250, s1: .84, s2: .7, r1: 26, r2: 34, o2: 1 };
      slides.forEach(function(s, k){
        var o = k - i; if (o > n / 2) o -= n; if (o < -n / 2) o += n;
        var a = Math.abs(o), sg = o < 0 ? -1 : 1, t, op = 1, veil = 0;
        if (o === 0) { t = 'translate3d(0,-10px,0)'; }
        else if (a === 1) { t = 'translate3d(' + (sg * w * c.x1) + 'px,' + c.y1 + 'px,' + c.z1 + 'px) rotateY(' + (-sg * c.r1) + 'deg) scale(' + c.s1 + ')'; veil = .36; }
        else if (a === 2) { t = 'translate3d(' + (sg * w * c.x2) + 'px,' + c.y2 + 'px,' + c.z2 + 'px) rotateY(' + (-sg * c.r2) + 'deg) scale(' + c.s2 + ')'; veil = .56; op = c.o2; }
        else { t = 'translate3d(' + (sg * w * 2) + 'px,' + c.y2 + 'px,' + (c.z2 - 80) + 'px) rotateY(' + (-sg * c.r2) + 'deg) scale(.6)'; op = 0; veil = .7; }
        s.style.transform = t; s.style.opacity = op; s.style.zIndex = 20 - a; s.style.pointerEvents = op ? '' : 'none';
        s.style.setProperty('--veil', veil);
        s.classList.toggle('is-active', o === 0);
        s.setAttribute('aria-hidden', o === 0 ? 'false' : 'true');
        var link = s.querySelector('a'); if (link) link.setAttribute('tabindex', o === 0 ? '0' : '-1');
      });
      bars.forEach(function(b, k){ b.classList.toggle('is-active', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(n);
    }
    function go(k){ i = ((k % n) + n) % n; layout(); }
    function restart(){ if (!auto) return; clearInterval(timer); timer = setInterval(function(){ go(i + 1); }, auto * 1000); }
    function stop(){ clearInterval(timer); }
    var prev = root.querySelector('[data-bb-prev]'), next = root.querySelector('[data-bb-next]');
    if (prev) prev.addEventListener('click', function(){ go(i - 1); restart(); });
    if (next) next.addEventListener('click', function(){ go(i + 1); restart(); });
    bars.forEach(function(b){ b.addEventListener('click', function(){ go(parseInt(b.getAttribute('data-bb-go'), 10)); restart(); }); });
    var sx = 0, sy = 0, down = false, dragged = false;
    stage.addEventListener('pointerdown', function(e){ down = true; dragged = false; sx = e.clientX; sy = e.clientY; });
    stage.addEventListener('pointermove', function(e){ if (down && Math.abs(e.clientX - sx) > 10 && Math.abs(e.clientX - sx) > Math.abs(e.clientY - sy)) dragged = true; });
    window.addEventListener('pointerup', function(e){ if (!down) return; down = false; var dx = e.clientX - sx; if (dragged && Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); } });
    stage.addEventListener('pointercancel', function(){ down = false; });
    stage.addEventListener('click', function(e){
      var s = e.target.closest('[data-bb-slide]'); if (!s) return;
      if (dragged) { e.preventDefault(); dragged = false; return; }
      if (!s.classList.contains('is-active')) { e.preventDefault(); go(parseInt(s.getAttribute('data-index'), 10)); restart(); }
    }, true);
    root.addEventListener('keydown', function(e){ if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); } });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', restart);
    window.addEventListener('resize', layout);
    if (mq.addEventListener) mq.addEventListener('change', layout);
    layout(); restart();
  }
  function boot(){ document.querySelectorAll('[data-bb-show]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', function(e){ var s = e.target.closest && e.target.closest('[data-bb-slide]'); if (!s) return; var root = s.closest('[data-bb-show]'); var b = root && root.querySelector('[data-bb-go="' + s.getAttribute('data-index') + '"]'); if (b) b.click(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
